import SimpleNumberInput from './SimpleNumberInput';

export default SimpleNumberInput;
